import { useState } from "react";

export default function usePaginationHook(input) {
  const [pagination, setPagination] = useState({
    active: input?.initialPage || 1,
    pagesize: input?.initialPageSize || 15,
    totalItems: input?.initialTotalItems || 0,
  });

  return {
    ...pagination,
    setPage: (pageNumber) =>
      setPagination((prev) => ({ ...prev, active: pageNumber })),

    setPageSize: (pageSize) =>
      setPagination((prev) => ({ ...prev, pagesize: pageSize })),

    setTotalItems: (itemCount) =>
      setPagination((prev) => ({ ...prev, totalItems: itemCount })),
    totalPages: Math.ceil(
      (pagination.totalItems || pagination.pagesize) / pagination.pagesize
    ),

    apiParams: {
      skip: (pagination.active - 1) * pagination.pagesize,
      pagesize: pagination.pagesize,
    },
  };
}
